import React, { useCallback, useContext, useEffect, useRef } from 'react'
import { stateContext } from './Context';
import { InsertTable } from './InsertTable';
import { KeyboardShortcuts } from './KeyboardShortcuts';
import '../assets/stylesheets/Modal.css'

export const Modal = () => {

  let {showModal, setShowModal, targetButton} = useContext(stateContext)

  const modalRef = useRef();
  
  let insertTableStyle = {
    width: 'fit-content',
    height: 'fit-content',
  }

    
  //close modal when click outside
  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      setShowModal(false);
    }
  };

    //close modal on ecs key press
    const keyPress = useCallback((e) => {
        if (e.key === "Escape" && showModal) {
            setShowModal(false);
        }
    },[setShowModal, showModal]);

    useEffect(() => {
        document.addEventListener("keydown", keyPress);
        return () => document.removeEventListener("keydown", keyPress);
    }, [keyPress]);

  return (
    <div className="modal-background" ref={modalRef} onClick={closeModal}>
      <div className="modal-wrapper" style={targetButton === 'Insert table' ? insertTableStyle : null}>
        <span
          className="close"
          onClick={() => {
            setShowModal(false);
          }}
        >
          &#10006;
        </span>
        {
            targetButton === 'Keyboard Shortcuts' ? (
                <KeyboardShortcuts />          
            ) : null
        }
        {
          targetButton === 'Insert table' ? (
            <InsertTable />
          ) : null
        }
      </div>
    </div>
  )
}
